// Esta función se utiliza para abrir un acordeon o una pestaña desde un anchor link
// Se utiliza ahora en fichas de arte de museos al hacer click en la siguiente copia en venta (next unit for sale)

function scrollToOpenAnchor() {
    /* El mismo contenido puede estar pintado de tres formas segun donde viva y en que
       viewport: acordeon suelto, acordeon de la tira de pestañas (movil) o pestaña
       (desktop). Solo una de las tres esta visible a la vez, asi que se busca la que
       este pintada y se le manda el click */
    const findTrigger = (anchorID) => {
        const candidates = [
            `.accordion-item#${anchorID} > [data-toggle-accordion]`,
            `.woocommerce-accordion-item.woocommerce-Tabs-panel--${anchorID} > [data-toggle-accordion]`,
            `[data-sc-toggle="tab"][data-sc-target="#tab-pane-${anchorID}"]`,
        ];

        return candidates
            .map((selector) => document.querySelector(selector))
            .find((trigger) => trigger && trigger.offsetParent !== null);
    };

    /* Abre lo que corresponda y deja el contenido a la vista. Devuelve si ha encontrado
       algo, que al llegar con el ancla en la URL hace falta saberlo. */
    const abrirYMostrar = (anchorID) => {
        const trigger = findTrigger(anchorID);

        if (!trigger) return false;

        const isTab = trigger.matches('[data-sc-toggle="tab"]');

        const isOpen = isTab
            ? trigger.classList.contains("active")
            : trigger.closest("[data-accordion]").classList.contains("open");

        // El toggle es un interruptor: clicar lo que ya esta abierto lo cerraria
        if (!isOpen) {
            trigger.click();
        }

        /* Al abrir un acordeon ya scrollea accordion.js; la pestaña no mueve la
           pagina, y el acordeon ya abierto tampoco vuelve a dispararlo */
        if (isTab || isOpen) {
            trigger.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        return true;
    };

    /* Los enlaces .toOpenAnchor solo estan en algunas fichas (arte de museos). Antes la
       funcion se iba de vacio cuando no habia ninguno, y con ella se iba tambien el
       tratamiento del ancla de la URL, que no depende de esos enlaces: llegar de fuera a
       una ficha de producto con #tab-pane-spare-parts no abria nada. Si no hay enlaces,
       el forEach no hace nada y la funcion sigue devolviendo el abridor. */
    document.querySelectorAll(".toOpenAnchor").forEach((anchorLink) => {
        anchorLink.addEventListener("click", (event) => {
            const anchorID = anchorLink.getAttribute("href").replace("#", "");

            if (abrirYMostrar(anchorID)) {
                event.preventDefault();
            }
        });
    });

    return abrirYMostrar;
}

/* Llegar de fuera con el ancla puesta tiene que hacer lo mismo que el clic: abrir el
   panel y bajar hasta el. El navegador no lo hace por su cuenta porque un panel que no
   esta activo no se pinta, y a un elemento sin caja no hay donde scrollear; por eso la
   tarjeta de un recambio del grid dejaba al visitante arriba de la ficha.

   Se admiten las dos formas de escribir el ancla que hay en la web: el id del panel
   (#tab-pane-spare-parts, que es lo que enlazan las tarjetas de recambios) y el del
   contenido (#transactions, del resumen de las obras). */
function abrirAnclaDeLaUrl(abrirYMostrar) {
    const hash = decodeURIComponent(window.location.hash).replace("#", "");

    if (!hash || typeof abrirYMostrar !== "function") return;

    abrirYMostrar(hash.replace(/^tab-pane-/, ""));
}

const abrirYMostrar = scrollToOpenAnchor();

/* Al terminar de cargar y no antes: la pagina sigue moviendose mientras entran imagenes y
   arrancan los carruseles, y un scroll calculado a mitad de camino acaba en otro sitio. */
if (document.readyState === "complete") {
    abrirAnclaDeLaUrl(abrirYMostrar);
} else {
    window.addEventListener("load", () => abrirAnclaDeLaUrl(abrirYMostrar), { once: true });
}

// Cambiar de ancla dentro de la misma pagina (volver atras, otro enlace) hace lo mismo
window.addEventListener("hashchange", () => abrirAnclaDeLaUrl(abrirYMostrar));
